import { Component, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { PopoverController } from '@ionic/angular';

import * as moment from 'moment';

@Component({
  selector: 'app-modal-selecionar-certificado',
  templateUrl: './modal-selecionar-certificado.component.html',
  styleUrls: ['./modal-selecionar-certificado.component.scss'],
})
export class ModalSelecionarCertificadoComponent {

  @Input() covid: boolean = false;
  @Input() civp: boolean = false;

  constructor(
    private popoverController: PopoverController
  ) { }

  selecionar(tipo: string) {
    this.popoverController.dismiss(tipo);
  }
}
